import type { ReactNode } from 'react';
import { isSsoEnabled } from '../auth/cognitoConfig';
import SsoGate from './SsoGate';
import TokenGate from './TokenGate';

interface ApiConfigGateProps {
  children: ReactNode;
}

/**
 * Chooses the access-control gate at build time:
 *   - Cognito SSO ("Sign in with Google") when VITE_COGNITO_* is configured, or
 *   - the legacy runtime shared-token screen otherwise.
 *
 * The choice is fixed for the app's lifetime (it depends only on build-time
 * env), so the two gates never swap at runtime.
 */
function ApiConfigGate({ children }: ApiConfigGateProps) {
  if (isSsoEnabled()) {
    return <SsoGate>{children}</SsoGate>;
  }
  return <TokenGate>{children}</TokenGate>;
}

export default ApiConfigGate;
